import React from "react";
import { Input, Label } from "reactstrap";
import SelectAgency from "pages/Users/SelectAgency";
import { useIsPseaAdmin } from "./usePseaPermissions";

const LABEL = "On behalf of (Agency Assessing)";

/**
 * The agency that assessed the contractor. Defaults to the logged-in user's
 * agency; only PSEA admins may point the assessment at a different agency.
 */
const AssessingAgencyField = ({ validation }: { validation: any }) => {
  const isAdmin = useIsPseaAdmin();

  if (isAdmin) {
    return <SelectAgency validation={validation} label={LABEL} />;
  }

  return (
    <div className="mb-3">
      <Label htmlFor="agency-readonly" className="form-label">
        {LABEL}
      </Label>
      <Input
        id="agency-readonly"
        className="form-control"
        type="text"
        disabled
        placeholder="No agency set"
        value={validation.values.agency?.label || ""}
      />
    </div>
  );
};

export default AssessingAgencyField;
